<div class="content-wrapper">
    <div class="content-body">
        <section id="package">
            <ng-template #content>
                <div id="modal">
                    <div class="modal-header font-weight-bold">
                        <h4 class="modal-title font-weight-bold">Update Status</h4>
                        <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                (click)="modalService.dismissAll('')"
                        >
                            ×
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <form class="form" novalidate [formGroup]="updateStatusForm">
                                    <div class="px-3 container">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="form-group">
                                                    <label for="status" class="d-flex">
                                                        Status
                                                    </label>
                                                    <select class="form-control" id="status"
                                                            formControlName="status">
                                                        <option value="">Select status</option>
                                                        <option >IN PROGRESS</option>
                                                        <option >COMPLETED</option>
                                                    </select>
                                                    <!--<small *ngIf="submitted && updatePasswordForm.get('password').hasError('required')"
                                                           class="text-danger">
                                                        Field is required.
                                                    </small>-->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success color-white pull-right" [disabled]="submitting"
                        >
                            <i class="fas fa-pen-square mr-1" *ngIf="!submitting"></i>
                            <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Update
                        </button>
                    </div>
                </div>
            </ng-template>
            <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <h2 class="mt-5px">Tickets</h2>
                </div>
                <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-12">
                    <button class="btn btn-primary pull-right color-white color-white users-btn"
                            (click)="showSearch = !showSearch">
                        <i aria-hidden="true" class="fa fa-search mr-8px"></i>&nbsp;Search
                    </button>
                    <button class="btn btn-primary pull-right color-white color-white users-btn mr-2"
                            (click)="add()">
                        <i aria-hidden="true" class="fa fa-list-alt mr-8px"></i>&nbsp;Create Ticket
                    </button>
                </div>
            </div>
            <div class="row search-card mt-3" *ngIf="showSearch">
                <div class="col-12">
                    <form class="form mt-2 mb--8px" novalidate [formGroup]="searchForm">
                        <div class="row">
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="subject" placeholder="Subject">
                                </fieldset>
                            </div>
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <select class="form-control" formControlName="type">
                                        <option value="">Select Type</option>
                                        <option value="FINANCIAL">Financial</option>
                                        <option value="PRODUCT">Product</option>
                                        <option value="TECHNICAL">Technical</option>
                                        <option value="GENERAL">General</option>
                                        <option value="OTHERS">Others</option>
                                    </select>
                                </fieldset>
                            </div>
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <select class="form-control" formControlName="status">
                                        <option value="">Select  Status</option>
                                        <option value="PLACED">Pending</option>
                                        <option value="DISPATCHED">Progress</option>
                                        <option value="DELIVERED">Completed</option>
                                        <option value="CANCELLED">Cancelled</option>
                                    </select>
                                </fieldset>
                            </div>
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12 text-center">
                                <button class="btn btn-primary btn-block btn-raised color-white mr-2 users-btn"
                                        (click)="search()"
                                        [disabled]="submitting">
                                    <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Search
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12">
                    <div class="row mt-3">
                        <div class="col-12">
                            <div class="row mt-3"
                                 *ngIf="supportData && supportData.length > 0; else noDataToShow">
                                <div class="col-12">
                                    <div class="card" *ngFor="let ticket of supportData; let i = index">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                                    <span class="f_20 font-weight-bold">{{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1}}.</span>
                                                </div>
                                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 text-center mt-auto mb-auto">
                                                    <span class="font-weight-bold text-italic f_15  cursor-pointer"
                                                          (click)="openExternalUrl('invoice-pdf/')">{{ticket?.subject}}</span>
                                                    <br>
                                                    <small class="text-italic">subject.</small>
                                                </div>
                                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 text-center mt-auto mb-auto text-justify">
                                                    <span class="font-weight-bold text-italic f_15">{{ticket?.remark}}</span>
                                                    <br>
                                                    <small class="text-italic">Remark</small>
                                                </div>
                                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                                    <span class="font-weight-bold text-italic f_15 text-warning"
                                                          *ngIf="ticket['status'] === 'PENDING'">Pending</span>
                                                    <span class="font-weight-bold text-italic f_15 text-primary"
                                                          *ngIf="ticket['status'] === 'RESOLVED'">Resolved</span>
                                                    <span class="font-weight-bold text-italic f_15 text-danger"
                                                          *ngIf="ticket['status'] === 'REJECTED'">Rejected</span>
                                                    <br>
                                                    <small class="text-italic">Status</small>
                                                </div>
                                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                                    <div>
                                                        <span class="font-weight-bold text-italic f_15 text-primary cursor-pointer"
                                                              *ngIf="ticket['support_doc_image']"
                                                              (click)="openExternalUrl(imageBaseUrl+ticket['support_doc_image'].partial_url)">View</span>
                                                        <span class="font-weight-bold text-italic f_15"
                                                              *ngIf="!ticket['support_doc_image']">-</span>
                                                        <br>
                                                        <small class="text-italic">Document</small>
                                                    </div>
                                                </div>
                                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                                    <span class="font-weight-bold text-italic f_15">{{ticket?.created_at}}</span>
                                                    <br>
                                                    <small class="text-italic">Created At</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ng-template #noDataToShow>
                                <div class="row">
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="card shadow-5px">
                                            <div class="card-body text-italic text-center">
                                                <i class="fa fa-question-circle fa-4x" aria-hidden="true"></i>
                                                <h5 class="p-20px">No Support Ticket Found</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                    <div class="div">
                        <div class="col-xs-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <ngb-pagination class="d-flex justify-content-center" (pageChange)="onPageChange($event)"
                                            [(page)]="pagination.page"
                                            [boundaryLinks]="true"
                                            [collectionSize]="pagination.total"
                                            [maxSize]="5"
                                            [pageSize]="pagination.perpage">
                            </ngb-pagination>
                        </div>
                    </div>
                    <ng-template #noDataToShow>
                        <div class="row text-center">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="card ribbon-wrapper shadow-0 border p-0">
                                    <div class="card-body">
                                        <h5 class="p-100px mt-15px font-weight-bold">No data to show</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
            <ng-template #noDataToShow>
                <div class="row mt-3">
                    <div class="col-12">
                        <div class="card p-50px">
                            <div class="card-body text-center">
                                <div class="row">
                                    <div class="col-12">
                                        <i class="fa fa-list-alt fa-3x" aria-hidden="true"></i>
                                    </div>
                                    <div class="col-12 text-center">
                                        No Tickets to show
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <div class="row pagination-table">
                <!--<ngb-pagination class="pagination-primary" [collectionSize]="pagination.total"
                                [(page)]="pagination.page" [boundaryLinks]="true"
                                [pageSize]="pagination.perpage" [maxSize]="5"
                                (pageChange)="onPageChange($event)">
                    <ng-template ngbPaginationPrevious>
                        <span [data-feather]="'chevron-left'" [size]="18"
                              [class]="'font-weight-bolder'">
                        </span>
                    </ng-template>
                    <ng-template ngbPaginationNext>
                        <span [data-feather]="'chevron-right'" [size]="18"
                              [class]="'font-weight-bolder'">
                        </span>
                    </ng-template>
                </ngb-pagination>-->
            </div>
        </section>
        <core-sidebar
                class="modal modal-slide-in sidebar-todo-modal fade"
                name="add-ticket"
                overlayClass="modal-backdrop">
            <app-add-support-ticket [data]="data" (valueSubmitted)="getData($event)"></app-add-support-ticket>
        </core-sidebar>
    </div>
</div>
